module.exports = __webpack_public_path__ + "img/VE.cd759060.png";